<div class="page-password-recovery-info">
  <h1 class="text-center mb-4">{{ 'restorePwd.passwordRecovery' | transloco }}</h1>
  <div>{{ 'restorePwd.recoveryInfo' | transloco }}</div>
</div>
